// extracted by css-extract-rspack-plugin
export default {"notebookContainer":"xxjW4"};